import { useLocation, useNavigate } from "react-router-dom";
import { React, useEffect, useState, useRef } from 'react';
import { useSnackbar } from 'notistack';

// material
import { Typography, Button, Box, Stack, Tooltip, TextField, ToggleButtonGroup, ToggleButton, Card, FormControl, FormLabel, Autocomplete } from '@mui/material';
import { styled } from '@mui/material/styles';
import XLSX from 'sheetjs-style';
import Moment from 'moment';
import * as FileSaver from 'file-saver';
import PeopleOutlineRoundedIcon from '@mui/icons-material/PeopleOutlineRounded';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
// components
import AddIcon from "@mui/icons-material/Add";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { Icon } from '@iconify/react';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';
import AppCache from '../../../services/AppCache';
import URLS from '../../../services/urls.service';
import Page from "../../Page";
import StickyHeader from "../../Common/StickyHeader";
import ServiceCards from '../../Common/ServiceCard'

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
const stripHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";
    return text.replace(/\s+/g, ' ').trim(); // collapse whitespace and remove line breaks
};

export default function ProjectTeamManagement() {
    const navigate = useNavigate();
    const location = useLocation();
    const [tab, setTab] = useState("teams");

    const handleChange = (event, newView) => {
        if (newView !== null) {
            setTab(newView);
        }
    };

    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setIsLoading] = useState();

    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();
    const [pageSize, setPageSize] = useState(25);

    const userId = CurrentLoggedInUser.ExecutiveId;
    // const [editServiceData, setEditServiceData] = useState([]);
    const [searchServiceId, setSearchServiceId] = useState('');
    const [issueId, setIssueId] = useState("");
    const [serviceId, setServiceId] = useState("");
    const [client, setClient] = useState("");
    const [selectedClient, setSelectedClient] = useState([]);

    const [project, setProject] = useState('');
    const [selectedProject, setSelectedProject] = useState([]);
    const [site, setSite] = useState("");
    const [selectedSite, setSelectedSite] = useState([]);
    const [reportedBy, setReportedBy] = useState('');
    const [selectedReportedBy, setSelectedReportedBy] = useState([])
    const [effectiveFromValue, setEffectiveFromValue] = useState(null);
    const [effectiveToValue, setEffectiveToValue] = useState(null);
    const [editData, setEditData] = useState([]);
    const [filteredServiceData, setFilteredServiceData] = useState(editData);
    const [editLoadData, setEditLoadData] = useState([]);

    useEffect(() => {
        URLS.getServiceEntryClientName()
            .then((response) => {
                setSelectedClient(Array.isArray(response.data) ? response.data : []);

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getServiceEntrySiteName({ ClientId: "0" })
            .then((response) => {
                setSelectedSite(Array.isArray(response.data) ? response.data : []);

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.loadExecutives()
            .then((response) => {
                setSelectedReportedBy(response.data);

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getServiceEntryProject()

            .then((response) => {
                setSelectedProject(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
    }, []);

    useEffect(() => {
        if (searchServiceId.trim() === '') {
            // No search → show full list
            setFilteredServiceData(editData);
        } else {
            const match = editData.find(
                (item) => String(item.ServiceId) === searchServiceId.trim()
            );
            setFilteredServiceData(match ? [match] : []);
        }
    }, [searchServiceId, editData]);

    const handleIssueId = (e) => {
        setIssueId(e.target.value);
    };
    const handleServiceId = (e) => {
        setServiceId(e.target.value);
    };
    const handleClient = (newValue) => {
        setClient(newValue?.ClientId || "");
    };
    const handleProject = (newValue) => {
        setProject(newValue?.ProjectVersionId || "");
    };
    const handleSite = (newValue) => {
        setSite(newValue?.SiteId || "");
    };

    const handleReportedBy = (newValue) => {
        setReportedBy(newValue?.Id || "");
    };
    const handleEffFrom = (newValue) => {
        setEffectiveFromValue(newValue);

    };

    const handleEffTo = (newValue) => {
        setEffectiveToValue(newValue);
    };

    const handleReset = () => {
        setClient("");
        setSite("");
        setReportedBy("");
        setIssueId("");
        setServiceId("");
        setEffectiveFromValue(null);
        setEffectiveToValue(null);
        setEditData([]);

    };

    const handleClick = (event, rowData) => {
        console.log("rowData", rowData, rowData?.ServiceId)
        URLS.editLoadServiceData({ ServiceId: rowData?.ServiceId })
            .then((response) => {
                const apiData = Array.isArray(response.data)
                    ? response.data[0]   //  object
                    : response.data;

                setEditLoadData(apiData);

                navigate("/dashboard/servicedetailspage", {
                    state: {
                        loadData: apiData, // object
                        openServiceTab: true,
                        fromEdit: true,
                    },
                });
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

        console.log("************************", rowData);
    };

    const exportToExcel = () => {
        const fileExtension = ".xlsx";
        const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

        // Columns to exclude
        const excludeColumns = [
            "ReportedById",
            "ClientId",
            "SiteId",
            "IssueOwnedById",
            "ReportingToId",
            "SubstatusId",
            "ProjectVersionId",
            "ReportedById",
            "ProjectId",
            "LastAllocatedById",
            "IssueCategoryId",
            "ActivityId",
            "ContactPersonId",
            "ExecutiveId",
            "ServiceTypeId",

        ];

        // Check if reports are available
        if (!filteredServiceData || filteredServiceData.length === 0) {
            enqueueSnackbar("No data available to export.", { variant: "error" });
            return;
        }

        // Prepare headers excluding unwanted columns
        const headers = Object.keys(filteredServiceData[0]).filter(
            (key) => !excludeColumns.includes(key)
        );
        // Prepare the row data based on reports data
        const dataToExport = filteredServiceData.map((row) =>
            headers.map((header) => {
                const cellValue = row[header];
                // Apply stripHtml if the value is a string
                return typeof cellValue === "string" ? stripHtml(cellValue) : cellValue;
            })
        );

        const dataWithHeaders = [headers, ...dataToExport]; // Combine headers with data rows
        const ws = XLSX.utils.aoa_to_sheet(dataWithHeaders); // Convert to AOA format
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] }; // Create workbook
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" }); // Write workbook to buffer
        const data = new Blob([excelBuffer], { type: fileType }); // Create a blob from the buffer

        const timestamp = Moment().format("DD-MMM-YYYY_HH-mm-ss");
        const fileName = `EditServiceListing_${timestamp}${fileExtension}`; // Add dynamic name

        FileSaver.saveAs(data, fileName); // Save the file
        enqueueSnackbar("Exported Excel successfully.", { variant: "success" });
    };

    const onFilterClick = () => {
        setIsLoading(true);
        const payload = {
            "IssueId": Number(issueId) || 0,
            "ServiceId": Number(serviceId) || 0,
            "UserId": userId || 0,
            "ClientId": client || 0,
            "SiteId": site || 0,
            "ContactPersonId": reportedBy || 0,
            "FromDate": effectiveFromValue ? Moment(effectiveFromValue).format("DD/MMM/YYYY") : "",
            "ToDate": effectiveToValue ? Moment(effectiveToValue).format("DD/MMM/YYYY") : ""
        }
        console.log("filter payload", payload)
        URLS.editLoadServiceFilter(payload)
            .then((response) => {


                if (Array.isArray(response.data) && response.data[0]?.Error) {
                    setEditData([]);
                    setIsLoading(false);

                    enqueueSnackbar(response.data[0].Error, { variant: 'error' });
                } else {
                    setEditData(response.data);

                    console.log("+++++++++++++++", response.data)
                    setIsLoading(false);
                    enqueueSnackbar("Fetched Data Successfully.", { variant: 'success' });
                }
            })
            .catch(error => {
                setEditData([]);
                enqueueSnackbar("Data not found", { variant: 'error' });
                setIsLoading(false);

            });
    };

    useEffect(() => {
        handleReset();
    }, [location.key]);

    return (
        <Page title="Project Team Management | tiketic" >
            <StickyHeader
                title="Project Team Management"
                showButton={false}

                rightContent={
                    <Stack direction="row" spacing={2} alignItems="center" mt={'2px'}>

                        <Button
                            variant="contained"
                            color="secondary"
                            startIcon={<AddIcon />}
                            sx={{
                                whiteSpace: "nowrap",
                                textTransform: "none",
                                mt: "3px",
                                "& .MuiButton-startIcon": { mr: "2px" },

                            }}
                        >
                            Create New Team
                        </Button>
                        <Tooltip title="Export To Excel">
                            <Button
                                variant="outlined"
                                sx={{
                                    whiteSpace: "nowrap",
                                    textTransform: "none",
                                    mt: "3px",
                                    "& .MuiButton-startIcon": { mr: "2px" },
                                    borderColor: "#2e7d32",
                                    color: "#2e7d32",
                                    "& .MuiButton-startIcon": { mr: "2px" },
                                    "&:hover": {
                                        backgroundColor: "#2e7d32",
                                        color: "#FFFFFF",
                                    },
                                    whiteSpace: "nowrap",
                                    textTransform: "none",
                                }}

                                startIcon={<FileUploadOutlinedIcon />}
                            >
                                Export
                            </Button>
                        </Tooltip>
                    </Stack>
                }
            />
            <ContentStyle>

                <Box sx={{
                    display: 'flex', gap: 2, height: '470px', px: 1.5,
                }}>
                    <Box sx={{ flex: 1, position: 'relative', display: 'flex' }}>
                        <Card sx={{ height: '480px', borderRadius: '15px', width: "100%", border: '1px solid #E5E5E5', boxShadow: 'none' }}>
                            {/* Header Row */}
                            <Box
                                sx={{
                                    py: 1,
                                    px: 2,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                {/* Left Side */}
                                <Box>
                                    <Typography fontSize={16} fontWeight={500}>
                                        Team Overview
                                    </Typography>
                                    <Typography sx={{ color: "#94A3B8", fontSize: "12px" }}>
                                        View and manage all team members
                                    </Typography>
                                </Box>

                                {/* Right Side */}
                                <Box
                                    sx={{
                                        backgroundColor: "#F3F3F5",
                                        borderRadius: 1,
                                        display: "flex",
                                    }}
                                >
                                    <ToggleButtonGroup
                                        exclusive
                                        sx={{
                                            "& .MuiToggleButton-root": {
                                                border: "none",
                                                textTransform: "none",
                                                borderRadius: "8px",
                                                px: 2,
                                                py: 0.5,
                                                color: "#121212",
                                            },
                                            "& .Mui-selected": {
                                                backgroundColor: "#ffffff",
                                                color: "#121212",
                                                boxShadow: "none",
                                                borderRadius: "8px",

                                            },
                                        }}
                                    >
                                        <ToggleButton value="teams">
                                            <PeopleOutlineRoundedIcon sx={{ fontSize: 18, mr: 0.5 }} />
                                            Teams
                                        </ToggleButton>

                                        <ToggleButton value="members">
                                            <AccountCircleOutlinedIcon sx={{ fontSize: 18, mr: 0.5 }} />
                                            Members
                                        </ToggleButton>
                                    </ToggleButtonGroup>
                                </Box>
                                <FormControl fullWidth size="small">
                                    <Autocomplete
                                        fullWidth
                                        limitTags={2}
                                        size="small"
                                        id="client"

                                        value={selectedClient.find((option) => option.ClientId === client) || ""}
                                        onChange={(_, newValue) => handleClient(newValue)}
                                        options={[{ Id: 0, Name: "Select" }, ...selectedClient]}

                                        getOptionLabel={(option) => option.Name || ""}
                                        isOptionEqualToValue={(option, value) => option.ClientId === value.ClientId}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder={
                                                    client.length === 0 ? "Select Option" : ""
                                                }
                                            />
                                        )}
                                        renderOption={(props, option) => (
                                            <li {...props} key={option.ClientId}>
                                                {option.Name}
                                            </li>
                                        )}
                                    />
                                </FormControl>
                                <FormControl size="small" fullWidth>

                                    <Autocomplete
                                        fullWidth
                                        size="small"
                                        id="project Version"
                                        value={selectedProject.find((item) => item.ProjectVersionId === project) || null}
                                        onChange={(_, newValue) => handleProject(newValue)}
                                        options={selectedProject}
                                        getOptionLabel={(option) => option.ProjectVersionName || ""}
                                        isOptionEqualToValue={(option, value) => option.ProjectVersionId === value.ProjectVersionId}
                                        renderOption={(props, option) => (
                                            <li {...props} key={option.ProjectVersionId}>
                                                {option.ProjectVersionName}
                                            </li>
                                        )}
                                        renderInput={(params) => <TextField {...params} placeholder="Enter Project" />}

                                    />
                                </FormControl>
                                <FormControl size="small" fullWidth>

                                    <Autocomplete
                                        fullWidth
                                        size="small"
                                        id="project Version"
                                        value={selectedProject.find((item) => item.ProjectVersionId === project) || null}
                                        onChange={(_, newValue) => handleProject(newValue)}
                                        options={selectedProject}
                                        getOptionLabel={(option) => option.ProjectVersionName || ""}
                                        isOptionEqualToValue={(option, value) => option.ProjectVersionId === value.ProjectVersionId}
                                        renderOption={(props, option) => (
                                            <li {...props} key={option.ProjectVersionId}>
                                                {option.ProjectVersionName}
                                            </li>
                                        )}
                                        renderInput={(params) => <TextField {...params} placeholder="Enter Project" />}

                                    />
                                </FormControl>
                                <Button
                                    variant="outlined"
                                    sx={{
                                        whiteSpace: "nowrap",
                                        textTransform: "none",
                                        mt: "3px",
                                        "& .MuiButton-startIcon": { mr: "2px" },
                                        "& .MuiButton-startIcon": { mr: "2px" },
                                        border: " 1px solid #D1D5DB",
                                        whiteSpace: "nowrap",
                                        textTransform: "none",
                                    }}

                                    startIcon={<FileUploadOutlinedIcon />}
                                >
                                    Show All Inactive
                                </Button>
                                <Tooltip title="Filter">

                                    <Button
                                        variant="contained"
                                        size="small"
                                        onClick={onFilterClick}

                                    ><Icon icon="ic:outline-filter-alt" width="25px" height="25px" /></Button>
                                </Tooltip >
                                <Tooltip title="Reset">

                                    <Button
                                        variant="contained"
                                        size="small"
                                        onClick={handleReset}
                                    ><Icon icon="ic:twotone-restart-alt" width="25px" height="25px" /></Button>

                                </Tooltip >
                            </Box>

                            {/* Scrollable Service Cards Section */}
                            {editData?.length > 0 ? (

                                <Box sx={{ height: '68vh', overflowY: 'auto', p: 2, }}>
                                    <ServiceCards
                                        serviceData={filteredServiceData}
                                        handleClick={handleClick}
                                        variant="edit"
                                    />
                                </Box>
                            ) : (
                                <Box
                                    sx={{
                                        height: '68vh',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexDirection: 'column',
                                        textAlign: 'center',
                                    }}
                                >
                                    <Typography sx={{ color: '#E7000B', fontSize: 16, fontWeight: '500' }}>
                                        No Data Found
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: '#928A8A', mt: 0.5 }}>
                                        Apply filters to view results
                                    </Typography>
                                </Box>
                            )}
                        </Card>
                    </Box>

                </Box>
            </ContentStyle>
            {isLoading && (<LoadingProgressBar sx={{ py: 9 }} />)}

        </Page>
    );
}

